var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showEnvironmentBanner)?_c('div',{staticClass:"environment-banner"},[_c('h1',[_vm._v("IFE Data "+_vm._s(_vm.toTitleCase(_vm.environment))+" Environment")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }